/* eslint-disable-next-line no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable-next-line no-unused-vars */
import { FxPreviewFieldsContent } from 'axp-fx-common';
/* eslint-disable-next-line no-unused-vars */
import { ButtonPrimary } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { actionDetailFields } from './actionsInitData';

const ActionsDetail = ({ row, props }) => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );
  const { timeZoneLocation } = loginData?.userDetail?.timeZone || {};
  const { activateFxAccount } = props;

  if (row) {
    return (
      <div className="pad-4">
        <FxPreviewFieldsContent
          component={{
            fields: actionDetailFields(timeZoneLocation),
            id: 'stepDetail',
          }}
          section={{
            stepDetail: row,
          }}
        />
        <div className="flex flex-justify-center margin-4-t">
          <ButtonPrimary onClick={() => activateFxAccount(row)}>
            Activate
          </ButtonPrimary>
        </div>
      </div>
    );
  }

  return <div>No data found</div>;
};

ActionsDetail.propTypes = {
  row: PropTypes.shape({}).isRequired,
  props: PropTypes.shape({
  }).isRequired,
  activateFxAccount: PropTypes.func.isRequired,
};

export default ActionsDetail;
